import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "@mui/material"
import { IAgency } from "agency/model"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
// import { NotificationSliderIcon } from "notification/components/NotificationSliderIcon"
import { faCartShopping, faGear, faRightFromBracket } from "@fortawesome/pro-solid-svg-icons"
import { SETTINGS_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { connect } from "react-redux"
import { DarkModeSwitch } from "ui/components/DarkModeSwitch"
import { addImportant } from "ui/tools/common"
import { isDarkThemeActive, setTheme } from "ui/tools/theme"
import { logoutAndRedirectToHomePage } from "user/tools/common"
import { canViewAgencyPage } from "user/tools/permissions"
import { FlexBox } from "../../ui/components/FlexBox"
import { LocalesPopupMenu } from "./LocalesPopupMenu"

interface IUserActionButtonsProps {
  displaySettings?: boolean
}

interface IUserActionButtonsConnectProps {
  agencyId: number | null
  agencies: IAgency[] // used only to refresh the UI
  isDark: boolean
}

const UserActionButtonsFn = React.memo(
  ({ isDark, agencyId, displaySettings }: IUserActionButtonsProps & IUserActionButtonsConnectProps) => {
    const canViewAgency = canViewAgencyPage(agencyId)
    return (
      <FlexBox
        jc="space-between"
        className="user-action-buttons"
        sx={{
          "pt": 0,
          "pb": 0,
          "width": "100%",
          "& .icon": {
            color: theme => theme.palette.text.primary2,
            transition: "all 300ms ease",
            fontSize: "1.5rem",
            p: ".5rem",
            cursor: "pointer"
          },
          "& .icon:hover, & .icon:hover *": {
            color: theme => addImportant(theme.palette.primary.main as string)
          },
          "& #notification-slider > svg": {
            fontSize: "2rem"
          }
        }}>
        {/* <NotificationSliderIcon />*/}
        <DarkModeSwitch id="user-theme-checkbox" isDark={isDark} setIsDark={newIsDark => setTheme(newIsDark)} />
        <LocalesPopupMenu />
        {canViewAgency && (
          <Tooltip placement="top" title={translate("agency.add.budget.help")}>
            <span id="user-agency-button" onClick={() => navigate({ path: SETTINGS_PATH, pathParams: "agency" })}>
              <FontAwesomeIcon icon={faCartShopping} className="icon" />
            </span>
          </Tooltip>
        )}
        {displaySettings && (
          <Tooltip placement="top" title={translate("settings.page.title")}>
            <span id="user-settings" onClick={() => navigate({ path: SETTINGS_PATH, pathParams: "profile" })}>
              <FontAwesomeIcon icon={faGear} className="icon" />
            </span>
          </Tooltip>
        )}
        <Tooltip placement="top" title={translate("logout.title")}>
          <span id="user-logout-button" onClick={() => logoutAndRedirectToHomePage()}>
            <FontAwesomeIcon icon={faRightFromBracket} className="icon" />
          </span>
        </Tooltip>
      </FlexBox>
    )
  }
)

export const UserActionButtons = connect(
  (state: IRootState): IUserActionButtonsConnectProps => ({
    agencies: state.agency.agencies,
    agencyId: state.user.user.agency_id,
    isDark: isDarkThemeActive(state)
  })
)(UserActionButtonsFn)
